<mat-card *ngIf="clientName">
  <div class="row">
    <div class="col-12">
      <h1 class="hello">Olá, {{clientName}}!</h1>
    </div>
  </div>
  <div class="row" *ngIf="dashboardStatus.INADIMPLENTE">
    <div class="col-12">
      <div class="alert alert-warning text-center">
        <strong>Constam em nossos registros que você está com alguma mensalidade em atraso. Por favor, faça o pagamento para garantir a continuidade do seu contrato e o livre acesso ao seu box.<br/></strong>
      </div>
    </div>
  </div>
  <div class="row" routerLink="/principal/cartoes-credito" *ngIf="dashboardStatus.MOSTRAR_BANNER_CARTAO_CREDITO">
    <div class="col-12">
      <div class="alert alert-info">
        <div class="row">
          <div class="col-xs-12 col-md-12 text-center">
            <strong>Cadastre seu cartão de crédito para cobrança automática agora mesmo!</strong>
            <br>
            Evite esquecimentos, juros e multas por atraso. Clique aqui e faça o cadastro!
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label="Faturas em aberto">
      <div *ngIf="datasourceMovements.data.length <= 0">
        <br>
        <div class="row">
          <div class="col-12">
            <div class="alert alert-success text-center">
              <strong>Nenhuma fatura em aberto encontrada.</strong>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="datasourceMovements.data.length > 0">
<!--        <mat-form-field style="width: 40%">-->
<!--          <mat-label>Filtro</mat-label>-->
<!--          <input matInput (keyup)="applyFilterInvoice($event)" placeholder="Ex.: Descrição" #inputInvoice>-->
<!--        </mat-form-field>-->
        <table mat-table [dataSource]="datasourceMovements" class="mat-elevation-z8">
          <ng-container matColumnDef="MES_REFERENCIA">
            <th mat-header-cell *matHeaderCellDef>Referência</th>
            <td mat-cell *matCellDef="let element">{{element.MES_REFERENCIA.toString().padStart(2, "0") + "/" + element.ANO_REFERENCIA}} </td>
          </ng-container>
          <ng-container matColumnDef="DESCRICAO_LOJA_CONTRATO">
            <th mat-header-cell *matHeaderCellDef>Contrato</th>
            <td mat-cell *matCellDef="let element">Contrato {{element.GEN_CONTRATO}} da unidade {{element.DESCRICAO_LOJA_CONTRATO}} </td>
          </ng-container>
          <ng-container matColumnDef="DATA_EMISSAO">
            <th mat-header-cell *matHeaderCellDef>Emitido em</th>
            <td mat-cell *matCellDef="let element">{{element.DATA_EMISSAO | date}} </td>
          </ng-container>
          <ng-container matColumnDef="DATA_VENCIMENTO">
            <th mat-header-cell *matHeaderCellDef>Vence em</th>
            <td mat-cell *matCellDef="let element">{{element.DATA_VENCIMENTO | date}} </td>
          </ng-container>
          <ng-container matColumnDef="VALOR_TOTAL">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let element"> {{element.VALOR_TOTAL | currency: 'BRL'}} </td>
          </ng-container>
          <ng-container matColumnDef="VENCIMENTO">
            <th mat-header-cell *matHeaderCellDef>Vencimento</th>
            <td mat-cell *matCellDef="let element"> {{element.VENCIMENTO | date}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsMovements"></tr>
          <tr mat-row [class]="row.INADIMPLENTE ? 'text-danger' : ''" *matRowDef="let row; columns: displayedColumnsMovements;" (click)="openMovement(row.CODIGO_FATURA)" [title]="row.INADIMPLENTE ? 'Esta fatura está em atraso' : ''"></tr>
<!--          <tr class="mat-row" *matNoDataRow>-->
<!--            <td class="mat-cell" colspan="3">Nada encontrado para o filtro {{inputInvoice.value}}</td>-->
<!--          </tr>-->
        </table>
      </div>
    </mat-tab>
    <mat-tab label="Contratos">
<!--      <mat-form-field style="width: 40%">-->
<!--        <mat-label>Filtro</mat-label>-->
<!--        <input matInput (keyup)="applyFilterContract($event)" placeholder="Ex.: Número do contrato" #input>-->
<!--      </mat-form-field>-->
      <table mat-table [dataSource]="dataSourceContracts" class="mat-elevation-z8" *ngIf="dataSourceContracts.data.length; else semContrato">
        <ng-container matColumnDef="GEN_CONTRATO">
          <th mat-header-cell *matHeaderCellDef>Contrato</th>
          <td mat-cell *matCellDef="let element"> {{element.GEN_CONTRATO}} </td>
        </ng-container>
        <ng-container matColumnDef="DESCRICAO">
          <th mat-header-cell *matHeaderCellDef>Box</th>
          <td mat-cell *matCellDef="let element"> {{element.DESCRICAO}} </td>
        </ng-container>
        <ng-container matColumnDef="DESCRICAO_LOJA">
          <th mat-header-cell *matHeaderCellDef>Unidade</th>
          <td mat-cell *matCellDef="let element"> {{element.DESCRICAO_LOJA}} </td>
        </ng-container>
        <ng-container matColumnDef="DATA_LOCACAO">
          <th mat-header-cell *matHeaderCellDef>Início do contrato</th>
          <td mat-cell *matCellDef="let element"> {{element.DATA_LOCACAO | date}} </td>
        </ng-container>
        <ng-container matColumnDef="VALOR_BASE">
          <th mat-header-cell *matHeaderCellDef>Valor base</th>
          <td mat-cell *matCellDef="let element"> {{element.VALOR_BASE | currency: 'BRL'}} </td>
        </ng-container>
        <ng-container matColumnDef="FINALIZAR_CONTRATO_DATA">
          <th mat-header-cell *matHeaderCellDef>Encerramento do contrato</th>
          <td mat-cell *matCellDef="let element">{{element.FINALIZAR_CONTRATO_DATA ? (element.FINALIZAR_CONTRATO_DATA | date) : '(Em vigor)'}} </td>
        </ng-container>
        <ng-container matColumnDef="INADIMPLENCIA">
          <th mat-header-cell *matHeaderCellDef>Status financeiro</th>
          <td mat-cell *matCellDef="let element"> {{element.INADIMPLENCIA ? 'Inadimplente' : 'Em dia'}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsContracts"></tr>
        <tr [class]="row.INADIMPLENCIA ? 'text-danger': ''" mat-row *matRowDef="let row; columns: displayedColumnsContracts;" (click)="openContract(row.GEN_CONTRATO)"></tr>
<!--        <tr class="mat-row" *matNoDataRow>-->
<!--          <td class="mat-cell" colspan="3">Nada encontrado para o filtro {{input.value}}</td>-->
<!--        </tr>-->
      </table>
      <ng-template #semContrato>
        <br>
        <div class="row">
          <div class="col-12">
            <div class="alert alert-info text-center"><strong>Nenhum contrato ativo encontrado</strong></div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
